import React from "react";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import SEO from "./SEO";
import HomeLogIn from "./screens/HomeLogIn";
import HomeOwner from "./screens/owner/HomeOwner"; // Import the HomeOwner component
import AdminPages from "./screens/admin/AdminPages"; // Import the AdminHome component
import ForgettingPassword from "./screens/ForgettingPassword";
import AssistantPages from "./screens/assistant/AssistantPages";
import PrivacyPolicy from "./PrivacyPolicy";
import PollsPage from "./screens/owner/PollsPage";
import Statistics from "./screens/owner/Statistics";

function App() {
  return (
    <div className="App">
      <SEO />
      {/* <Router> */}
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/*" element={<HomeLogIn />} />
          <Route path="/owner-home" element={<HomeOwner />} />
          <Route path="/owner/statistics" element={<Statistics />} />
          <Route path="/owner/polls" element={<PollsPage />} />
          <Route path="/admin-home/*" element={<AdminPages />} />
          <Route path="/assistant-home/*" element={<AssistantPages />} />
          <Route path="/forgot-password" element={<ForgettingPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
